<template lang="pug">
	div.text-left.listado(style="cursor:default;")
		.arrow-up
		.cabecera
			.row
				.col
					span.fa.fa-bell.mr-2
					| Notificaciones ({{nuevas.length}})
				.col.text-right
					span.txtEliminarTodas(@click="eliminarTodas") Eliminar todas
		Notificacion(
			v-for="(notificacion, i) in listadoNotificaciones"
			:key="notificacion.NotificacionID",
			:notificacion="notificacion"
			:index="i"
			@descartar="descartar($event)"
			:class="(notificacion.FechaDescartada) ? 'cerrada' : ''"
			@cerrar="cerrar"
		)
		div.noNoti(v-if="listadoNotificaciones.length === 0")
			span.fa.fa-bell-slash
			div No tienes notificaciones
</template>


<script>
import Notificacion from './notificacion'
import { mapGetters, mapActions } from 'vuex'
export default {
	components: {
		Notificacion
	},
	computed: {
		...mapGetters({
			listadoNotificaciones: 'notificaciones/listado',
			nuevas: 'notificaciones/nuevas'
		})
	},
	watch: {
		listadoNotificaciones () {
			let noLeidas = 0
			for (let i = 0; i < this.listadoNotificaciones.length; i++) {
				if (!this.listadoNotificaciones[i].FechaMostrada) {
					noLeidas++
				}
			}

			if (noLeidas) {
				this.setLeidas()
			}
		}
	},
	created () {
		// this.setLeidas()
	},
	beforeDestroy () {
		this.setLeidas()
	},
	methods: {
		...mapActions({
			descartar: 'notificaciones/del',
			descartarTodas: 'notificaciones/delTodas',
			setLeidas: 'notificaciones/leidas'
		}),
		eliminarTodas () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar todas las notificaciones',
				mensaje: '¿Quieres eliminar todas las notificaciones?',
				callback: acepta => {
					if (acepta) {
						this.descartarTodas()
					}
				}
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>
<style scoped>
.cabecera {
	position: relative;
	display: block;
	text-align: left;
	padding: 5px;
	padding-left: 10px;
	font-weight: bold;
	background-color: white;
	color: #222222;
	border-bottom: 1px solid rgba(100, 100, 100, 0.2);
}
.listado {
	box-shadow: 0 0px 9px rgba(0,0,0,0.2);
	border: 1px solid rgba(100, 100, 100, 0.4);
}

.arrow-up {
  width: 0; 
  height: 0; 
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  
  border-bottom: 10px solid white;
  position: absolute;
  display: block;
  right: 6px;
  top: -10px;
}

.noNoti {
	text-align: center;
	position: relative;
	display: block;
	background-color: white;
	color: #222222;
	padding-top: 15px;
	padding-bottom: 15px;
}

.noNoti > span {
	font-size: 1.5em;
	margin: 5px;
}

.noNoti > div {
	font-weight: bold;
	font-size: 1em;
}

.txtEliminarTodas {
	opacity: 0.5;
	cursor: pointer;
}
.txtEliminarTodas:hover {
	text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/notificaciones/listado.vue